
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_site/[city]/domru-tv/channel/[alias]",
      function () {
        return require("private-next-pages/_site/[city]/domru-tv/channel/[alias].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_site/[city]/domru-tv/channel/[alias]"])
      });
    }
  